<template>
  <div class="error-modal">
    <BaseModalContent :name="name" :dynamic="true" @close="$emit('close')">
      <div class="mb-m">
        <h2 class="error-modal__title">
          {{ title }}<span v-if="status"> ({{ status }})</span>
        </h2>
      </div>
      <p v-if="content" class="mb-s">{{ content }}</p>
      <div v-if="message" class="mb-l error-modal__error">
        <p>{{ message }}</p>
      </div>
      <div class="mt-l">
        <BaseButton @click="$emit('close')">Закрыть</BaseButton>
      </div>
    </BaseModalContent>
  </div>
</template>

<script>
export default {
  name: "ErrorModal",
  props: {
    title: {
      type: String,
      default: "Произошла ошибка",
    },
    content: {
      type: String,
    },
    message: {
      type: String,
    },
    status: {
      type: [String, Number],
    },
  },
  data() {
    return {
      name: "error-modal",
    };
  },
};
</script>
<style lang="less" scoped>
.error-modal {
  &__title {
    font-size: @font-size-h4;
    line-height: @line-height-h4;
    font-weight: bold;
  }

  &__error {
    color: @error-color;
  }

  @media (max-width: @screen-xs-max) {
    .error-modal {
      &__title {
        font-size: @font-size-l;
        line-height: @line-height-l;
      }
    }
  }
}
</style>
